<template>
  <div class="flex flex_column" style="height:100%">
    <h5 class="font_bold">{{activeItemIndex + 1}} - {{pafList.length}}</h5>
    <div class="flex_1 pdf_list_box">
      <div
        class="pdf_item flex flex_column"
        @click="checkItem(item,index)"
        v-for="(item,index) in pafList"
        :key="index"
        :class="activeId===item.receivableId?'active_pdf':''"
      >
        <div class="flex flex_center">
          <div class="flex flex_column flex_start pdf_status">
            <i v-if="item.invoiceDocumentFileId && item.invoiceNumber" class="fa fa-circle valid_color"></i>
            <i v-else-if="item.invoiceDocumentFileId" class="fa fa-circle warn_color"></i>
            <i v-else class="fa font_lg  fa-file-o  invalid_color"></i>
          </div>
          <i class="fa fa-file-text file_bg inactive_color" aria-hidden="true"></i>
        </div>
        <span v-if="item.invoiceDocumentFileId" class="wrap_p">{{item.invoiceDocumentFilename}}</span>
      </div>
    </div>
    <div>
    </div>
  </div>
</template>
<script>
import {mapGetters} from "vuex";

export default {
  props: {
    activeId: [String, Number],
    getDetail: Function
  },
  data() {
    return {
      activeItemIndex: 0
    };
  },
  methods: {
    checkItem(item, index) {
      if (this.activeId === item.receivableId) return;

      let activeItem = this.pafList[this.activeItemIndex];
      let data = {
        item: item,
        index: index
      };

      if (activeItem.changed) {
        let option = {
          msg: this.$t("seller.upload.unsaved.warning"),
          confirmFun: this.switchPdf,
          params: {
            item: item,
            index: index
          }
        };

        this.confirmMeg(option, true);
      } else {
        this.switchPdf(data);
      }
    },
    switchPdf(data) {
      this.$store.dispatch("setActionActivePdf", data.item);
      this.getDetail(data.item.receivableId);
    },
    updateActiveItemIndex() {
      this.activeItemIndex = this.pafList.findIndex(pdf => pdf.receivableId === this.activePdf.receivableId);
    }
  },
  computed: {
    ...mapGetters(["pafList", "activePdf"]),
  },
  watch: {
    activePdf() {
      this.updateActiveItemIndex();
    },
    pafList() {
      this.updateActiveItemIndex();
    }
  }
};
</script>